import './client-list.scss'

import { Space } from '@/components/core-v2'

import { ClientsState } from '../clients/clients.state'
import { DfmsState } from '../clients/dfm.state'
import { useClientsLayout } from '../clients-layout-provider'
import { ClientItem } from './client-item'

export type Props = {
  onSelectBusinessUnit?: (businessUnitId: string) => void
  onSelectClient: (clientId: string) => void
  state: ClientsState | DfmsState
}

export function ClientList({ onSelectBusinessUnit, onSelectClient, state }: Props) {
  const { isPortfolioManagerScreen } = useClientsLayout()

  const items = isPortfolioManagerScreen
    ? (state as DfmsState).filteredDfms
    : (state as ClientsState).filteredClients

  const selectedItemId = isPortfolioManagerScreen
    ? (state as DfmsState).selectedDfm?.dfmId
    : (state as ClientsState).selectedClient?.clientId

  return (
    <Space mt={3}>
      <ul className="client-list">
        {items?.map(item => {
          const id = isPortfolioManagerScreen ? item.dfmId : item.clientId

          return (
            <ClientItem
              key={id}
              isExpanded={item.isExpanded}
              isSelected={selectedItemId && id === selectedItemId}
              item={item}
              selectedBusinessUnit={(state as ClientsState).selectedBusinessUnit}
              onClickBusinessUnit={onSelectBusinessUnit}
              onClickItem={() => onSelectClient(id)}
            />
          )
        })}
      </ul>
    </Space>
  )
}
